export default "__VITE_ASSET__C3O9m6HJ__"